import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../services/PostData';
import { GetData } from '../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table,
	Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import ManagePage from '../views/ManagePage';
const GLOBAL = require('../Globals');

class Manage extends Component {

	constructor(props) {
		super(props);
		this.state = {
			id: '',
			acyear: '',
			cls: '',
			section: '',
			attdate: moment(),
			_message: '',
			alertClass: '',
			posts: [],
			stud: [],
			data: [],
			accyear: [],
			chk: '',
			att: [],
			remark: [],
			postFilter: [],
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onClassChange = this.onClassChange.bind(this);
		this.onSecChange = this.onSecChange.bind(this);
	}


	onRemarkChange(id, e) {

		var index = this.state.att.findIndex(function (obj) {
			return (obj.id == id);
		});

		if (index != -1) {

			this.state.att[index].remarks = e.target.value;

		}
		console.log(this.state.att);

	}

	checkChange(id, e) {

		if (e.target.checked) {
			var index = this.state.att.findIndex(function (obj) {
				// var obj=JSON.parse(objstr);
				return (obj.id == id);
			});

			if (index === -1) {
				this.state.att.push({ "id": id, "remarks": 0 });
			}

		}
		else {

			for (var i = 0; i < this.state.att.length; i++) {

				// var obj=JSON.parse(this.state.att[i]);

				if ((this.state.att[i].id == id)) {

					this.state.att.splice(i, 1);
					break;
				}
			}
		}
		// console.log(this.state.att);
	}

	/** set value to Attendance datepicker **/
	handleChange(date) {
		this.setState({
			attdate: date
		});
	}

	onSecChange(e) {

		this.state.section = e.target.value;
		this.filterdata();
	}


	onClassChange(e) {

		this.state.cls = e.target.value;
		this.filterdata();
	}
	onChange(e) {

		this.setState({ [e.target.name]: e.target.value });
		this.getstudent();
	}

	onSubmit(e) {
		e.preventDefault();
		$("#showLoader").show();
		PostData('homework/homeworkentry', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				/* this.setState({
					_message:'Attendance Added Successfully!..',
					alertClass:'alert alert-success',
				}); */
				alert('HomeWork Verified  Successfully!..');
				document.getElementById("attform").reset();
				this.state.postFilter = [];
				this.state.att = [];
				$("#attab").hide();
			}
			else {

				this.setState({
					_message: 'Error!..',
					alertClass: 'alert alert-danger',
				});
			}
		});
	}

	/** this function will be call when page loading **/
	componentWillMount() {

		this.getclass();
		this.getacyear();
	}

	/** get Class **/
	getclass() {

		GetData('homework/getclassinhw').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}

	/** Get Academic Year **/
	getacyear() {

		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				this.getstudent();
			}
		});
	}

	/** get Student **/
	getstudent() {
		$("#showLoader").show();
		this.setState({ stud: [] });
		var ac = $("#year").val();
		GetData('student/getstdbyac/' + ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					stud: responseJson,
					postFilter: responseJson
				});
			}
		});
	}

	filterdata() {

		this.state.postFilter = [];
		var dat = [];
		for (var i = 0; i < this.state.stud.length; i++) {

			if (this.state.cls != '' && this.state.section != '') {

				if (this.state.stud[i].class == this.state.cls && this.state.stud[i].section == this.state.section) {

					dat.push(this.state.stud[i]);
				}
			}

		}
		this.setState({ postFilter: dat });
	}

	render() {

		/** disable weekend(sunday) in react-datepicker **/
		var isWeekday = (date) => {
			const day = date.day()
			return day !== 0 && day !== 7
		}

		if (this.state._redirect) {

			return (<Redirect to='/student/attendanceview' />);
		}

		var items = this.state.posts;
		var sub = this.state.subj;
		var tea = this.state.teach;
		var acyear = this.state.accyear;

		if (this.state.acyear != '' && this.state.cls != '' && this.state.section != '') {

			$("#attab").show();

		}
		else {

			$("#attab").hide();
		}

		/** get Section By Class **/
		$("#clas").change(function () {
			var fr = $(this).val();
			var ar = $("#year").val();
			$("#showLoader").show();
			$.get(GLOBAL.BASE_URL + 'section/getsecbyclass/' + ar + '/' + fr, function (o) {
				$("#showLoader").hide();
				$("#secs").html('');
				$('#secs')
					.append($("<option></option>")
						.attr("value", '')
						.text(' -Select Section- '));
				$.each(o, function (key, value) {
					$('#secs')
						.append($("<option></option>")
							.attr("value", value.id)
							.text(value.secs));

				});

			}, 'json');


		});

		$('.selectall').click(function () {
			if ($(this).is(':checked')) {
				$('table input').attr('checked', true);
			} else {
				$('table input').attr('checked', false);
			}
		});

		return (
			<div>
				<ManagePage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<form action="" method="post" role="form" id="attform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<Row>
							<Col md="12">
								<Card>
									<CardHeader>
										<strong>Home Work</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
										Academic Year : &nbsp;&nbsp;
							<select name="acyear" onChange={this.onChange} required id="year">
											<option value="">Select</option>
											{
												acyear.map(function (item) {
													return <option value={item.id}>{item.value}</option>;
												})
											}
										</select>
									</CardHeader>
									<CardBody>
										<Row>
											<Col md="3">
												<FormGroup>
													<Label htmlFor="name">Class <span className="text-danger">*</span></Label>
													<select name="cls" onChange={this.onClassChange} className="form-control" id="clas" required>
														<option value="">Select Class</option>
														{
															items.map(function (item) {
																return <option value={item.id}>{item.class}</option>;
															})
														}
													</select>
												</FormGroup>
											</Col>
											<Col md="3">
												<FormGroup>
													<Label htmlFor="name">Section <span className="text-danger">*</span></Label>
													<select name="section" onChange={this.onSecChange} className="form-control" id="secs" required>

													</select>
												</FormGroup>
											</Col>

											<Col md="3">
												<FormGroup>
													<Label htmlFor="name">Date <span className="text-danger">*</span></Label>
													<DatePicker selected={this.state.attdate} id="attendancedate" onChange={this.handleChange} className="form-control" dateFormat="DD-MM-YYYY" filterDate={isWeekday} />
												</FormGroup>
											</Col>
										</Row>
									</CardBody>
								</Card>
							</Col>
							<Col md="12" id="attab">
								<Card>
									<CardHeader className="card-header-inner">
										<strong>Home Work</strong>
									</CardHeader>
									<CardBody>
										<Row>
											<Col md="12">
												<Table responsive bordered striped id="atttable">
													<thead>
														<tr>
															<th>Check Homework</th>
															<th>Reg No</th>
															<th>Student Name</th>
															<th>Remarks</th>
														</tr>
													</thead>
													<tbody>
														{this.state.postFilter.map(item =>

															<tr key={item}>
																<td><input type="checkbox" id="chk_all" name="chk_select" onClick={this.checkChange.bind(this, item.regno)} /></td>
																<td>{item.regno}</td>
																<td>{item.stdname}</td>
																<td><input type="text" name="remarks" id={item.id} onChange={this.onRemarkChange.bind(this, item.regno)} /></td>
															</tr>
														)}
													</tbody>
												</Table>
											</Col>
										</Row>
									</CardBody>
									<CardFooter>
										<Button type="submit" size="sm" color="primary" className="btn-right"><i className="fa fa-dot-circle-o"></i> Submit</Button>
									</CardFooter>
								</Card>
							</Col>
						</Row>
					</form>
				</div>
			</div>
		)
	}
}

export default Manage;


// WEBPACK FOOTER //
// ./src/homework/manage.js